import { render, staticRenderFns } from "./dialogSelGoodsMultiple.vue?vue&type=template&id=0b0c78e4&scoped=true"
import script from "./dialogSelGoodsMultiple.vue?vue&type=script&lang=js"
export * from "./dialogSelGoodsMultiple.vue?vue&type=script&lang=js"
import style0 from "./dialogSelGoodsMultiple.vue?vue&type=style&index=0&id=0b0c78e4&prod&lang=less&scoped=true"
import style1 from "./dialogSelGoodsMultiple.vue?vue&type=style&index=1&id=0b0c78e4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0c78e4",
  null
  
)

export default component.exports